<form [formGroup]="model.asForm" (ngSubmit)="enviar()">
    <div>
        <div>
            <div>
                <span class="text-black"> Poderia nos dizer o motivo que deseja uma nova proposta? </span>
            </div>
            <div class="mt-2">
                <div class="form-group">
                    <textarea rows="3" class="form-control" id="observacao" aria-describedby="observacao"
                        maxlength="900"
                        placeholder="Por favor, descreva em poucas palavras seu motivo"
                        formControlName="motivo"></textarea>
                    <div class="invalid-feedback-inputs"
                        *ngIf="!validarFormulario && model.asForm.controls.motivo.invalid">
                        <span> Campo obrigatório </span>
                    </div>
                    <div class="textarea-contador-wrapper">
                        <span class="textarea-contador">{{ model.asForm.controls.motivo.value?.length || 0 }}/900</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<div class="row mt-3">
    <div class="col-6">
        <button class="btn btn-outline-secondary btn-sm w-100" (click)="fechar()">Cancelar</button>
    </div>
    <div class="col-6">
        <button (click)="enviar()" class="btn btn-primary float-end btn-sm w-100">Ok</button>
    </div>
</div>